import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";

import { StoryDeprecated } from "@hermes/api-model-editorial";

export const fetchStory = createAction(
    "[Story] Fetch Story",
    props<{ path: string; searchTerm: string | undefined }>(),
);

export const fetchHomepageStory = createAction("[Story] Fetch Homepage Story");

export const fetchStorySuccess = createAction(
    "[Story] Fetch Story Success",
    props<{ story: StoryDeprecated; searchTerm: string | undefined }>(),
);

export const fetchHomepageStorySuccess = createAction(
    "[Story] Fetch Homepage Story Success",
    props<{ story: StoryDeprecated }>(),
);

export const fetchStoryFailure = createAction(
    "[Story] Fetch Story Failure",
    props<{ error: HttpErrorResponse }>(),
);
